import React from 'react';
import {FLEX_DIRECTION, useDevice, View} from '@lookiero/aurora';
import {styles} from './Intro.styles';
import {IntroMedia} from './components';
import {IDS} from './intro.definition';
import {IntroContent} from '@/pages/Home/components/Intro/components/IntroContent';

const Intro: React.FC = () => {
  const {screen} = useDevice();

  return (
    <View as="section" flexDirection={screen.L ? FLEX_DIRECTION.ROW : FLEX_DIRECTION.COLUMN} nativeID={IDS.SECTION}>
      <IntroContent />
      <View as="aside" nativeID={IDS.IMAGE} style={styles.media}>
        <IntroMedia />
      </View>
    </View>
  );
};

const MemoizedIntro = React.memo(Intro);
export {MemoizedIntro as Intro};
